// import NationalChlTable from "./NationalChlTable";
// export default NationalChlTable;
export { NationalChnlTable as default } from "./NationalChnlTable";
